<template>
  <div
    v-if="show"
    class="post-preview js-open-preview"
  >
    <div class="post-preview__content">
      <app-post-preview-close-button @click.native="hide()" />
      <div class="post-preview__content-inner">
        <div class="post-preview__content-img">
          <img :src="imageurl">
        </div>
        <div class="post-preview__content-body">
          <div class="">
            <app-title-text
              class=""
              :text="title"
            />
            <p
              class="post-preview__content-body-text"
              v-text="text"
            />
            <app-primary-user-button
              v-if="show_button"
              class="mt30"
              :title="button_text"
              :link="button_link"
              :target="button_link_target"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus, action } from "@/utility/event-bus";

export default {
  props: {
    title: String,
    text: String,
    button_text: String,
    button_link: String,
    button_link_target: String,
    imageurl: String,
    command: String
  },
  data() {
    return {
      show: this.command == 'show',
      show_button: !!this.button_text && !!this.button_link,
    };
  },
  created() {
    eventBus.$on(action.SHOW_POST_PREVIEW, () => {
      this.show = true;
    });
  },
  methods: {
    hide() {
      this.show = false;
    }
  }
};
</script>

<style scoped>
</style>
